import React from "react";

import { CmsHeaderNavigationSettings1, Level1MenuBlock } from "@reactivated";

import { Clickable } from "../Clickables";

import styles from "./main-menu.module.scss";

const Level1 = ({
    value,
    closeMenu,
}: {
    value: Level1MenuBlock;
    closeMenu: () => void;
}) => {
    if (!value.link) return;

    return (
        <li>
            <Clickable
                simpleLink={value.link}
                className={styles.linkLevel1}
                onPress={() => closeMenu()}
            />
            {value.level_2_items && value.level_2_items.length > 0 && (
                <ul className={styles.menuLevel2}>
                    {value.level_2_items.map((level2Link, index) => (
                        <li key={`level2-${index}`}>
                            <Clickable
                                simpleLink={level2Link}
                                className={styles.linkLevel2}
                                onPress={() => closeMenu()}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};

interface Props {
    menu: CmsHeaderNavigationSettings1;
    active: boolean;
    closeMenu: () => void;
}

export const MainMenu = ({ active, menu, closeMenu }: Props) => {
    if (menu.value.length === 0) return <></>;

    return (
        <div className={active ? styles.rootActive : styles.rootInactive}>
            <div className={styles.grid}>
                <ul className={styles.level1}>
                    {menu.value[0].value.map((level1, index) => (
                        <Level1
                            value={level1}
                            key={`level1-${index}`}
                            closeMenu={closeMenu}
                        />
                    ))}
                </ul>
            </div>
        </div>
    );
};
